import { Subject } from "observable-fns";
import { singleton } from "tsyringe";
import { ContextBase } from "views/ContextBase";

export class DialogSettings{
    constructor(msg: string, onResult: (result: boolean) => any, title: string = null){
        this.msg = msg;
        this.onResult = onResult;
        this.title = title;
    }
    title: string;
    msg: string;
    onResult: (result: boolean) => any        
}

export class AuthDialogSettings{
    constructor(onResult: (result: boolean) => any, title: string = null){
        this.onResult = onResult;
        this.title = title;
    }
    public title: string;
    public onResult: (result: boolean) => any        
}

export class EventOrchestrator<T>{
    protected event = new Subject<T>();
    protected eventEmitter = this.event;   
    protected emitChange(val: T) {
        this.event.next(val);
    }

    
    public setValue(val: T): void {
        this.emitChange(val);
    }

    public subscribe(handler: (val: T) => any){
        this.eventEmitter.subscribe(handler);
    }
}

@singleton()
export class AppContext extends ContextBase {
    public readonly dialogEvent; 
    public readonly authDialogEvent;

    constructor(){
        super();
        this.dialogEvent = new EventOrchestrator<DialogSettings>();
        this.authDialogEvent = new EventOrchestrator<AuthDialogSettings>();

    }

    public setDialogVisibility(settings: DialogSettings): void {
        this.dialogEvent.setValue(settings);
    }


}